import { useQuery } from '@tanstack/react-query';

import api from 'services/api';

const useInit = () => {
    const fetchInit = async () => {

        try {
            const response = await api.get(`api/v1/init?`);
            const {
                data: { payload, meta },
            } = await response.json();

            return { data: payload, meta };
        } catch (e) {
            return Promise.reject(e);
        }
    };

    return useQuery(['init-v1'], () => fetchInit(), {
        refetchOnWindowFocus: false,
    });
};

export default useInit;
